/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RecommendationMonitorBatchSetStatusItemDto = {
    id: string;
    status: RecommendationMonitorBatchSetStatusItemDto.status;
};

export namespace RecommendationMonitorBatchSetStatusItemDto {

    export enum status {
        PENDING = 'PENDING',
        ACCEPTED = 'ACCEPTED',
        REFUSED = 'REFUSED',
    }


}
